export default {
    Metadata: {
        Name: "GetLoadedRecordCount",
        Description: "Returns the number of records currently loaded with any server filtering or paging applied",
        Syntax: "GetLoadedRecordCount()",
        Keywords: ['Records', 'Page', 'Loaded', 'Count'],
        Author: "DataVoke, Inc.",
        UpdatesOnData: true
    },
    execute() {
        let mvc = app.dv.helpers.exprEng.currexpression && app.dv.helpers.exprEng.currexpression.mvc;
        if (mvc != null) {
            // get the current number of records loaded in the MVC.
            return mvc.records.Values.length;
        }
        else {
            // unknown; return 0.
            return 0;
        }
    },
};

